import React from "react";
import SiteTableRow from "../SiteTableRow/SiteTableRow";
import "./SitesTable.css";

function SitesTable(props) {
  const rows = props.sites.reduce((acc, row, index) => {
    if (row.hide !== true) {
      acc.push(<SiteTableRow key={index} {...row} />);
    }
    return acc;
  }, []);

  return (
    <table>
      <thead>
        <tr>
          <th>URL</th>
          <th>HOME STATUS</th>
          <th>SSL STATUS</th>
          <th>SITE SPEED</th>
          <th>MOBILE SITE SPEED</th>
          <th>FLOORLYTICS</th>
          <th>BROKEN LINKS</th>
          <th>LAST RUN</th>
          <th className="column-line">RERUN</th>
        </tr>
      </thead>
      <tbody>{rows}</tbody>
    </table>
  );
}

export default SitesTable;
